import React, { useEffect } from 'react'
import {
    Route,
    Routes,
    Navigate,
    BrowserRouter,
} from 'react-router-dom'

import { MainMenuErrorBoundary } from 'App/ErrorBoundaries'
import Layout from './Layout'
import MainDashboard from './MainDashboard'
import LocationProvider, { LocationView } from './Location'
import ProcessesDashboard from './ProcessesDashboard'
import ProcessDashboard from './ProcessDashboard'
import ProcessPage from './ProcessPage'
import DirectScan from './DirectScan'
import Orders from './Orders'
import DirectScanProcessPage from './DirectScan/DirectScanProcessPage'

const getEnviroment = () => {
    const url = window.location

    if (url.host.includes('test')) {
        return ' (TEST)'
    }
    if (url.host.includes('dev')) {
        return ' (DEV)'
    }
    return null
}

const Root = () => {
    useEffect(() => {
        const env = getEnviroment()

        if (env) {
            document.title = `SkyCenter ${env}`
        }
    }, [])

    return (
        <BrowserRouter future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
        }}
        >
            <LocationProvider>
                <MainMenuErrorBoundary>
                    <Layout>
                        <LocationView>
                            <Routes>
                                <Route
                                    path="/mainDashboard"
                                    element={<MainDashboard />}
                                />
                                <Route
                                    path="/scan"
                                    element={<DirectScan />}
                                />
                                <Route
                                    path="/processes/:type/:number"
                                    element={<ProcessPage />}
                                />
                                <Route
                                    path="/processes_directscan/:type/:number"
                                    element={<DirectScanProcessPage />}
                                />
                                <Route
                                    path="/processes/:type"
                                    element={<ProcessDashboard />}
                                />
                                <Route
                                    path="/processes"
                                    element={<ProcessesDashboard />}
                                />
                                <Route
                                    exact
                                    path="/orders"
                                    element={<Orders />}
                                />
                                <Route
                                    path="/"
                                    element={(
                                        <Navigate
                                            to="/mainDashboard"
                                            replace
                                        />
                                    )}
                                />
                            </Routes>
                        </LocationView>
                    </Layout>
                </MainMenuErrorBoundary>
            </LocationProvider>
        </BrowserRouter>
    )
}

export default Root
